import React, { Component } from 'react';
import { Collapse } from 'reactstrap';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavLink } from 'react-router-dom';

export default class SidebarCategory extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    icon: PropTypes.string,
    isNew: PropTypes.bool,
    children: PropTypes.arrayOf(PropTypes.element).isRequired,
  };

  static defaultProps = {
    icon: '',
    isNew: false,
  };

  render() {
    const {
      title, icon, isNew, children, changeSidebarVisibility, route
    } = this.props;
    const { collapse } = (title === "Maintenance" && window.location.href.indexOf("BinconsolidationConfirmation") > -1) ? { collapse: true } : this.props;
    const categoryClass = classNames({
      'sidebar__category-wrap': true,
      'sidebar__category-wrap--open': collapse,
      'sidebar__link sidebar__category': true,
    });

    return (
      <div>
        <NavLink
          to={route || '#'} 
          isActive={() => false} 
        >
        <button className={categoryClass} type="button" onClick={() => { this.props.ontoggle(title); }}>
          {icon ? <FontAwesomeIcon icon={icon} onClick={changeSidebarVisibility} /> : ''}

          <p className="sidebar__link-title">{title}
            {isNew && <span className="sidebar__category-new" />}
          </p>
          <span className="sidebar__category-icon lnr lnr-chevron-right" />
        </button>
        <Collapse isOpen={collapse} className="sidebar__submenu-wrap">
          <ul className="sidebar__submenu">
            <div>
              {children}
            </div>
          </ul>
        </Collapse>
        </NavLink>
      </div>
    );
  }
}